<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
export default {
  name: 'App',
  computed: {
    layout() {
      return `${this.$route.meta.layout || 'empty'}-layout`;
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

body {
  height: 100%;
}

.v-application svg.primary--text,
.v-application svg.secondary--text,
.v-application svg.success--text,
.v-application svg.info--text,
.v-application svg.warning--text,
.v-application svg.error--text {
  fill: currentColor !important;
}
</style>
